import React from 'react';
import {
  CheckCircleFilled,
  FileTextOutlined,
  MessageOutlined,
  DatabaseOutlined,
  RobotOutlined,
  BookOutlined,
  BranchesOutlined,
  NodeIndexOutlined,
} from '@ant-design/icons';

const STEP_META = {
  eform:    { icon: FileTextOutlined,    color: '#1677ff' },
  metaflow: { icon: NodeIndexOutlined,   color: '#6d28d9' },
  template: { icon: MessageOutlined,     color: '#13c2c2' },
  dataset:  { icon: DatabaseOutlined,    color: '#fa8c16' },
  aiStaff:  { icon: RobotOutlined,       color: '#eb2f96' },
  kb:       { icon: BookOutlined,        color: '#52c41a' },
  workflow: { icon: BranchesOutlined,    color: '#7234CF' },
};

const lbl = (t, key, fallback) => {
  const v = t(key);
  return !v || v === key ? fallback : v;
};

const BuildAppWizardStepper = ({ steps, currentIndex, completedIndices, t }) => {
  if (!steps || steps.length === 0) return null;

  return (
    <div style={styles.wrapper}>
      <div style={styles.track}>
        {steps.map((stepKey, idx) => {
          const meta = STEP_META[stepKey] || STEP_META.workflow;
          const Icon = meta.icon;
          const isDone = completedIndices.includes(idx);
          const isCurrent = idx === currentIndex;
          const isLast = idx === steps.length - 1;

          const label = lbl(t, `buildApp.wizardStep.${stepKey}`, stepKey);

          return (
            <React.Fragment key={stepKey}>
              <div style={styles.stepItem}>
                <div
                  style={{
                    ...styles.circle,
                    background: isDone ? '#52c41a' : isCurrent ? '#7234CF' : '#f0f0f0',
                    borderColor: isDone ? '#52c41a' : isCurrent ? '#7234CF' : '#d9d9d9',
                    color: isDone || isCurrent ? '#fff' : '#999',
                  }}
                >
                  {isDone ? (
                    <CheckCircleFilled style={{ fontSize: 18 }} />
                  ) : (
                    <Icon style={{ fontSize: 16 }} />
                  )}
                </div>
                <span
                  style={{
                    ...styles.label,
                    color: isCurrent ? '#7234CF' : isDone ? '#52c41a' : '#888',
                    fontWeight: isCurrent ? 600 : 400,
                  }}
                >
                  {label}
                </span>
              </div>
              {!isLast && (
                <div
                  style={{
                    ...styles.connector,
                    background: isDone ? '#52c41a' : '#e8e8e8',
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    background: '#fff',
    borderBottom: '1px solid #f0f0f0',
    padding: '12px 24px',
    flexShrink: 0,
    overflowX: 'auto',
  },
  track: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 'max-content',
    gap: 0,
  },
  stepItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
    minWidth: 72,
  },
  circle: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    border: '2px solid',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s',
  },
  label: {
    fontSize: 11,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  connector: {
    flex: '1 0 32px',
    height: 2,
    minWidth: 32,
    maxWidth: 64,
    margin: '0 4px',
    marginBottom: 18,
    borderRadius: 1,
  },
};

export default BuildAppWizardStepper;
